import {useSuiContext} from '@s-ui/react-context'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'
import {DECODING, FETCH_PRIORITY, LOADING, MediaImage, OBJECT_FIT} from '@adv-mt/ui/media-image'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../../config.js'
import AdvantageCard from '../advantageCard/index.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-advantages-sellVehicle`
const IPROMO_PARAM = 'ipromo=c2b-detail-service_module'

const SellVehicle = () => {
  const {domain, i18n} = useSuiContext()
  const {track: analyticsTrack} = useAnalyticsTrack()

  const config = domain.get('config')
  const {INSTANT_OFFER_STANDALONE_PATTERN} = config.get('page')
  const {
    TRACKING_EVENT_NAMES: {ACCESS_TO_INSTANT_OFFER_CLICKED},
    HIT_ORIGINS: {AD_DETAIL}
  } = config.get('tracking')
  const logoSrc = `${config.get('urlStatics')}${config.get('LOGO_URL')}`

  const handleClick = () => {
    analyticsTrack({
      event: ACCESS_TO_INSTANT_OFFER_CLICKED,
      data: {hit_origin: AD_DETAIL}
    })
  }

  return (
    <AdvantageCard
      href={`${INSTANT_OFFER_STANDALONE_PATTERN}?${IPROMO_PARAM}`}
      onClick={handleClick}
      title={i18n.t('COMMON.DETAIL_ADVANTAGES_SELL_VEHICLE_TITLE')}
      description={i18n.t('COMMON.DETAIL_ADVANTAGES_SELL_VEHICLE_DESCRIPTION')}
    >
      <MediaImage
        src={logoSrc}
        alt=""
        // Inert at current sizing (the box is pinned to the logo's own ratio); kept as a safety net
        // so a future change that reshapes the box letterboxes instead of distorting.
        objectFit={OBJECT_FIT.CONTAIN}
        loading={LOADING.LAZY}
        decoding={DECODING.ASYNC}
        fetchPriority={FETCH_PRIORITY.LOW}
        className={`${BASE_CLASS}-logos`}
      />
    </AdvantageCard>
  )
}

SellVehicle.displayName = 'SellVehicle'

export default SellVehicle
